import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/rh/collaborateurs/$id/")({
  staticData: {
    permission: PERMISSIONS.RH.EMPLOYES.VIEW,
  },
  component: () => <Outlet />,
});
